module.exports = __webpack_public_path__ + "static/media/CircleOfInfluenceDebrief.752d19c5.png";